import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Billing from "../views/Billing.vue";
import EmailLanding from "../views/EmailLanding.vue";
const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  {
    path: "/free",
    name: "Free",
    component: Home,
  },
  {
    path: "/starter",
    name: "Starter",
    component: Home,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/confirmation?",
    name: "Confirmation",
  },
  {
    path: "/create-account",
    name: "CreateAccount",
    component: EmailLanding,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/free",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
